import { requestHacoCms } from 'apis/base';
import { Pages } from './response_types';

export const getTerms = () => {
    return requestHacoCms<Pages>('get', '/pages', { q: "slug[eq]:terms" })
}

export const getLaws = () => {
    return requestHacoCms<Pages>('get', '/pages', { q: "slug[eq]:law" })
}

export const getPrivacy = () => {
    return requestHacoCms<Pages>('get', '/pages', { q: "slug[eq]:privacy" })
}